import React from 'react';
import cn from 'classnames';


export function highlightSubstring(string: string, substring: string): JSX.Element {
  function escapeRegExp(text: string) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  }
  const searchResults = string.split(new RegExp(`(${escapeRegExp(substring)})`, 'gi'));

  const renderBlock = searchResults.map((part, i) => (
    <span
      key={i}
      className={cn({
        highlight: part.toLowerCase() === substring.toLowerCase(),
      })}
    >
      {part}
    </span>
  ));

  return (
    <div>
      {renderBlock}
    </div>
  );
}
